// extracted by mini-css-extract-plugin
export default {"mainContainer":"TicketManager_mainContainer__kUHwY"};